import router from "../../router";
import leadService from "../../services/leadService";
import { i18n } from "../../main.js";

const getDefaultState = () => {
  return {
    isUuid: false,
    offers: [
      {
        id: 54,
        name: "Super",
        contractType: "variable",
        energy: "elec",
        idProduct: 900110,
        area: "all",
        duration: 1
      },
      {
        id: 55,
        name: "Super",
        contractType: "variable",
        energy: "gas",
        idProduct: 900246,
        area: "all",
        duration: 1
      },
      {
        id: 56,
        name: "Easy",
        contractType: "fixe",
        energy: "elec",
        idProduct: 900106,
        area: "all",
        duration: 1
      },
      {
        id: 57,
        name: "Easy",
        contractType: "fixe",
        energy: "elec",
        idProduct: 900106,
        area: "bx",
        duration: 1
      },
      {
        id: 58,
        name: "Easy",
        contractType: "variable",
        energy: "elec",
        idProduct: 900111,
        area: "all",
        duration: 1
      },
      {
        id: 59,
        name: "Easy",
        contractType: "variable",
        energy: "elec",
        idProduct: 900111,
        area: "bx",
        duration: 1
      },
      {
        id: 60,
        name: "Easy",
        contractType: "fixe",
        energy: "gas",
        idProduct: 900113,
        area: "all",
        duration: 1
      },
      {
        id: 61,
        name: "Easy",
        contractType: "fixe",
        energy: "gas",
        idProduct: 900113,
        area: "bx",
        duration: 1
      },
      {
        id: 62,
        name: "Easy",
        contractType: "variable",
        energy: "gas",
        idProduct: 900114,
        area: "all",
        duration: 1
      },
      {
        id: 63,
        name: "Easy",
        contractType: "variable",
        energy: "gas",
        idProduct: 900114,
        area: "bx",
        duration: 1
      },
      {
        id: 64,
        name: "Zen",
        contractType: "fixe",
        energy: "elec",
        idProduct: 900107,
        area: "all",
        duration: 3
      },
      {
        id: 65,
        name: "Zen",
        contractType: "fixe",
        energy: "elec",
        idProduct: 900107,
        area: "bx",
        duration: 3
      },
      {
        id: 66,
        name: "Zen",
        contractType: "fixe",
        energy: "elec",
        idProduct: 900107,
        area: "all",
        duration: 5
      },
      {
        id: 67,
        name: "Zen",
        contractType: "fixe",
        energy: "elec",
        idProduct: 900107,
        area: "bx",
        duration: 5
      },
      {
        id: 68,
        name: "Zen",
        contractType: "variable",
        energy: "gas",
        idProduct: 900115,
        area: "all",
        duration: 3
      },
      {
        id: 69,
        name: "Zen",
        contractType: "variable",
        energy: "gas",
        idProduct: 900115,
        area: "bx",
        duration: 3
      },
      {
        id: 70,
        name: "Zen",
        contractType: "variable",
        energy: "gas",
        idProduct: 900115,
        area: "all",
        duration: 5
      },
      {
        id: 71,
        name: "Zen",
        contractType: "variable",
        energy: "gas",
        idProduct: 900115,
        area: "bx",
        duration: 5
      },
      {
        id: 79,
        name: "Group",
        contractType: "variable",
        energy: "elec",
        idProduct: 900109,
        area: "all",
        duration: 1
      },
      {
        id: 80,
        name: "Group",
        contractType: "variable",
        energy: "gas",
        idProduct: 900245,
        area: "all",
        duration: 1
      },
      {
        id: 136,
        name: "Comfy",
        contractType: "",
        energy: "elec",
        idProduct: 900239,
        area: "all",
        duration: 1
      },
      {
        id: 137,
        name: "Comfy",
        contractType: "",
        energy: "gas",
        idProduct: 900240,
        area: "all",
        duration: 1
      },
      {
        id: 138,
        name: "Comfy",
        contractType: "",
        energy: "elec",
        idProduct: 900239,
        area: "bx",
        duration: 1
      },
      {
        id: 139,
        name: "Comfy",
        contractType: "",
        energy: "gas",
        idProduct: 900240,
        area: "bx",
        duration: 1
      }
    ],
    civilities: [
      {
        id: 20001,
        fr: "Madame",
        nl: "Mevrouw"
      },
      {
        id: 20003,
        fr: "Mademoiselle",
        nl: "Juffrouw"
      },
      {
        id: 20004,
        fr: "Monsieur et Madame",
        nl: "Meneer en Mevrouw"
      },
      {
        id: 20005,
        fr: "Monsieur",
        nl: "Meneer"
      },
      {
        id: 20006,
        fr: "Messieurs",
        nl: "Heren"
      },
      {
        id: 20007,
        fr: "Mesdames",
        nl: "Dames"
      }
    ]
  };
};

export default {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    setIsUuid(state, value) {
      state.isUuid = value;
    },
    setOffers(state, value) {
      state.offers = value;
    },
    setStateProperty(state, payload) {
      state[payload.param] = payload.value;
    },
    reset(state) {
      Object.keys(state).forEach(item => {
        delete state[item];
      });

      Object.assign(state, getDefaultState());
    }
  },
  actions: {
    async setLanguage(context, lang) {
      i18n.locale = lang;
      context.commit("common/setLang", lang, { root: true });
    },

    async setByUuid(context, uuid) {
      try {
        let lead = await leadService.get(uuid);

        Object.keys(lead).forEach(key => {
          context.commit("setStateProperty", {
            param: key,
            value: lead[key]
          });
        });

        if (lead.prospect) {
          Object.keys(lead.prospect).forEach(key => {
            context.commit("setStateProperty", {
              param: key,
              value: lead.prospect[key]
            });
          });
        }

        context.dispatch("setState");
      } catch (error) {
        throw error;
      }
    },

    // async setGlobalState(context, params) {
    //   Object.keys(params).forEach(param => {
    //     if (context.state.keys.includes(param)) {
    //       context.commit("setStateProperty", {
    //         param: param,
    //         value: params[param]
    //       });
    //     }
    //   });

    //   context.dispatch("setState");
    // },

    async setState(context) {
      context.commit("common/setUuid", context.state.uuid, { root: true });

      context.commit("common/setLang", context.state.language, { root: true });
      i18n.locale = context.state.language || 'fr';

      // energy
      if (context.state.energy) {
        context.commit("energy/setValid", true, { root: true });
        context.commit("energy/setType", context.state.energy, { root: true });
      }

      //consumptions
      if (
        (context.rootGetters["energy/hasElec"] &&
          (context.state.consumptionElecBase ||
            (context.state.consumptionElecLow &&
              context.state.consumptionElecHigh))) ||
        (context.rootGetters["energy/hasGas"] && context.state.consumptionGas)
      ) {
        let consumptions = [
          {
            meterType: "day",
            value: context.state.consumptionElecHigh
          },
          {
            meterType: "night",
            value: context.state.consumptionElecLow
          },
          {
            meterType: "mono",
            value: context.state.consumptionElecBase
          },
          {
            meterType: "exclusiveNight",
            value: context.state.consumptionElecNight
          },
          {
            meterType: "gas",
            value: context.state.consumptionGas
          }
        ];

        context.commit("consumption/setValid", true, {
          root: true
        });
        context.commit("consumption/setConsumptions", consumptions, {
          root: true
        });

        let meterTypes = [];
        consumptions.forEach(consumption => {
          if (consumption.value !== null)
            meterTypes.push(consumption.meterType);
        });
        context.commit("consumption/setMeterType", meterTypes, {
          root: true
        });
      }
      context.commit(
        "consumption/setHasSolarPanels",
        context.state.solarPanelsPower &&
          context.state.solarPanelsPower !== undefined &&
          context.state.solarPanelsPower.length > 0
          ? true
          : false,
        {
          root: true
        }
      );
      context.commit(
        "consumption/setSolarPanelsPower",
        context.state.solarPanelsPower,
        {
          root: true
        }
      );

      context.commit(
        "consumption/setKnowConsumption",
        context.state.knowConsumption,
        {
          root: true
        }
      );

      if (!context.state.knowConsumption) {
        context.commit("consumption/setEmptyHouse", context.state.emptyHouse, {
          root: true
        });
        context.commit("consumption/setPeople", context.state.people, {
          root: true
        });
        context.commit("consumption/setHouseSize", context.state.houseSize, {
          root: true
        });
        context.commit("consumption/setOccupation", context.state.occupation, {
          root: true
        });
        context.commit("consumption/setHeating", context.state.heating, {
          root: true
        });
        context.commit("consumption/setWater", context.state.water, {
          root: true
        });
        context.commit("consumption/setDryer", context.state.dryer, {
          root: true
        });
        context.commit("consumption/setDishwasher", context.state.dishwasher, {
          root: true
        });
      } else {
        context.commit(
          "consumption/setToDefault",
          {},
          {
            root: true
          }
        );
      }

      // calculation
      context.commit("calculation/setZipCode", context.state.zipCode, {
        root: true
      });

      if (context.state.zipCode) {
        context.commit("calculation/setValid", true, {
          root: true
        });

        context.commit("calculation/setCity", context.state.city, {
          root: true
        });

        context.commit("calculation/setArea", context.state.area, {
          root: true
        });

        context.commit(
          "calculation/setProviderElec",
          context.state.providerElec,
          {
            root: true
          }
        );
        context.commit(
          "calculation/setProviderGas",
          context.state.providerGas,
          {
            root: true
          }
        );

        context.commit("setIsUuid", true);
        // await context.dispatch("calculation/getProviders", {}, { root: true });
      } else {
        context.commit("calculation/setValid", false, {
          root: true
        });
      }

      context.commit("calculation/setSimulation", context.state.simulation, {
        root: true
      });

      // contact
      context.commit(
        "contact/setIsPro",
        context.state.type === "pro" ? true : false,
        {
          root: true
        }
      );
      context.commit("contact/setCivility", context.state.civility, {
        root: true
      });
      context.commit("contact/setFirstName", context.state.firstName, {
        root: true
      });
      context.commit("contact/setLastName", context.state.lastName, {
        root: true
      });
      context.commit("contact/setPhone", context.state.phone, {
        root: true
      });
      context.commit("contact/setMail", context.state.email, {
        root: true
      });
      context.commit("contact/setConsent", context.state.optin, {
        root: true
      });

      if (!context.state.simulation) {
        if (context.state.comparisonResult) {
          let myElecProduct = context.state.comparisonResult.electricity
            ? context.state.comparisonResult.electricity.competitor.find(
                product => product.id === "myElec"
              )
            : null;

          context.commit("comparison/setMyElecProduct", myElecProduct, {
            root: true
          });

          let myGasProduct = context.state.comparisonResult.gas
            ? context.state.comparisonResult.gas.competitor.find(
                product => product.id === "myGas"
              )
            : null;

          context.commit("comparison/setMyGasProduct", myGasProduct, {
            root: true
          });
        }

        context.commit(
          "comparison/setCompetitorElecProduct",
          context.state.competitorProductElec,
          {
            root: true
          }
        );
        context.commit(
          "comparison/setCompetitorGasProduct",
          context.state.competitorProductGas,
          {
            root: true
          }
        );
      } else {
      }
    },

    async newSession(context) {
      context.commit("reset");
      context.commit("common/reset", {}, { root: true });
      context.commit("energy/reset", {}, { root: true });
      context.commit("consumption/reset", {}, { root: true });
      context.commit("calculation/reset", {}, { root: true });
      context.commit("contact/reset", {}, { root: true });
      context.commit("comparison/reset", {}, { root: true });
    }
  },
  getters: {
    become: (state, getters, rootState, rootGetters) => range => {
      let url = "https://become.mega.be?newSession";

      if (router.currentRoute.query["campaign"])
        url += `&campagne=${router.currentRoute.query["campaign"]}`;
      if (router.currentRoute.query["agent"])
        url += `&codeAgent=${router.currentRoute.query["agent"]}`;
      if (router.currentRoute.query["agentRef"])
        url += `&refAgent=${router.currentRoute.query["agentRef"]}`;
      if (router.currentRoute.query["promo"])
        url += `&codePromo=${router.currentRoute.query["promo"]}`;

      url += `&lang=${i18n.locale}`;
      url += `&electricite=${rootGetters["energy/hasElec"] ? 1 : 0}`;
      url += `&gaz=${rootGetters["energy/hasGas"] ? 1 : 0}`;
      url += `&travauxvide=${rootState.consumption.emptyHouse ? 1 : 0}`;
      url += `&cp=${rootState.calculation.zipCode}`;

      if (rootState.contact.lastName)
        url += `&nom=${rootState.contact.lastName}`;

      if (rootState.contact.firstName)
        url += `&prenom=${rootState.contact.firstName}`;

      if (rootState.contact.mail) url += `&email=${rootState.contact.mail}`;
      if (rootState.contact.phone) url += `&mobile=${rootState.contact.phone}`;
      if (rootState.contact.isPro) url += `&pro`;

      let civility = state.civilities.find(
        civility => civility[i18n.locale] === rootState.contact.civility
      );
      if (civility !== undefined) {
        url += `&civilite=${civility.id}`;
      }

      // let offers = state.offers;

      // if (rootState.calculation.area === "bx") {
      //   offers = offers.filter(offer => offer.area === "bx");
      // } else {
      //   offers = offers.filter(offer => offer.area !== "bx");
      // }

      if (range && !rootState.calculation.simulation) {
        if (rootState.calculation.providerElec)
          url += `&elec_fournisseur=${rootState.calculation.providerElec}`;

        if (rootState.calculation.providerGas)
          url += `&gaz_fournisseur=${rootState.calculation.providerGas}`;

        // if (range.electricity) {
        //   let elecOffer = offers.find(
        //     offer =>
        //       offer.idProduct.toString() === range.electricity.productId &&
        //       offer.duration === range.electricity.duration
        //   );
        //   if (elecOffer !== undefined) url += `&elecOffre=${elecOffer.id}`;
        // }

        // if (range.gas) {
        //   let gasOffer = offers.find(
        //     offer =>
        //       offer.idProduct.toString() === range.gas.productId &&
        //       offer.duration === range.gas.duration
        //   );
        //   if (gasOffer !== undefined) url += `&gazOffre=${gasOffer.id}`;
        // }
      }

      // if (range && rootState.calculation.simulation) {
      //   if (range.electricity) {
      //     let elecOffer = offers.find(
      //       offer =>
      //         offer.idProduct.toString() === range.electricity.productId &&
      //         offer.duration === range.electricity.duration
      //     );
      //     if (elecOffer !== undefined) url += `&elecOffre=${elecOffer.id}`;
      //   }

      //   if (range.gas) {
      //     let gasOffer = offers.find(
      //       offer =>
      //         offer.idProduct.toString() === range.gas.productId &&
      //         offer.duration === range.gas.duration
      //     );
      //     if (gasOffer !== undefined) url += `&gazOffre=${gasOffer.id}`;
      //   }
      // }

      return url;
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/middleware.js